// extracted by mini-css-extract-plugin
export var brand = "_7y-8";
export var compact = "_7y-5";
export var extraSmall = "_7y-6";
export var icon = "_7y-0";
export var large = "_7y-3";
export var light = "_7y-1";
export var medium = "_7y-4";
export var outline = "_7y-a";
export var primaryDark = "_7y-9";
export var primaryLight = "_7y-7";
export var primaryModern = "_7y-b";
export var success = "_7y-2";